import StudentGradesRow from "./StudentGradesRow";
import { GradesDTO } from '../../../api/Quiz/HostedQuizGrades';
const StudentGrades = ({ data }: { data?: GradesDTO[] }) => {

    return (
        <div>
            <div className="overflow-x-auto scrollbar-thumb-blue scrollbar-thumb-rounded scrollbar-track-blue-lighter scrollbar-w-2 scrolling-touch">
                <table className="table-auto w-full">
                    <thead className="text-lg capitalize ">
                        <tr className="bg-[#F1F4F9] rounded-t-lg">
                            <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                                <div className="text-left text-sm">
                                    Full Name
                                </div>
                            </th>
                            <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                                <div className="text-left text-sm">
                                    Phone
                                </div>
                            </th>
                            <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                                <div className="text-left text-sm">
                                    Score
                                </div>
                            </th>

                        </tr>
                    </thead>
                    <tbody className="text-sm">
                        {data?.map((student: GradesDTO) => (
                            <StudentGradesRow
                                student={student.student}
                                phone={student.photo}
                                score={student.score}

                            />
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default StudentGrades;
